import { memo } from 'react'
import Hero from './homepage/Hero'

const Content = memo(() => {
  return (
    <main className="pt-20 lg:pt-0 min-h-screen">
      <Hero />
    </main>
  )
})

Content.displayName = 'Content'

export default Content
